import { useEffect, useRef, useState } from 'react';

// ─── Toast system ────────────────────────────────────────────────────────────
type ToastType = 'success' | 'error' | 'warning' | 'info';
type ToastItem = { id: number; message: string; type: ToastType };

let _toastId = 0;
let _setToasts: React.Dispatch<React.SetStateAction<ToastItem[]>> | null = null;

export function showToast(message: string, type: ToastType = 'success') {
  if (!_setToasts) return;
  const id = ++_toastId;
  _setToasts((prev) => [...prev, { id, message, type }]);
  setTimeout(() => {
    _setToasts?.((prev) => prev.filter((t) => t.id !== id));
  }, 3500);
}

export function ToastContainer() {
  const [toasts, setToasts] = useState<ToastItem[]>([]);
  useEffect(() => { _setToasts = setToasts; return () => { _setToasts = null; }; }, []);

  return (
    <div className="toast-container">
      {toasts.map((t) => (
        <div key={t.id} className={`toast-item toast-${t.type}`} role="status">
          <span className="toast-icon">{t.type === 'error' ? '⚠' : t.type === 'warning' ? '!' : t.type === 'success' ? '✓' : 'i'}</span>
          <span>{t.message}</span>
          <button type="button" className="toast-close" aria-label="Đóng thông báo"
            onClick={() => _setToasts?.((prev) => prev.filter((item) => item.id !== t.id))}>×</button>
        </div>
      ))}
    </div>
  );
}
